import React, { useContext } from 'react';
import { LanguageContext } from '../../Data/Context/languageContext';

const BuildRatio = ({ likes, dislikes, usersBuild }) => {
    const ratio = (10 / (likes + dislikes) * likes).toFixed(0);
    const { t } = useContext(LanguageContext);

    return (
        <>
            <div className='build-ratio d-none d-sm-flex'>
                <p>{ratio > 0 ? ratio : ''}</p>

                {ratio > 0 &&
                    '/10'
                }

                {likes === 0 && dislikes === 0 &&
                    <p>{t("not_rated_1")}</p>
                }

                {likes === 0 && dislikes > 0 &&
                    <>
                        <p className="negative-rate">0</p>
                        /10
                    </>
                }
            </div>

            <div className='build-ratio container-fluid d-sm-none text-center'>
                <p>{ratio > 0 ? t("rating") + ": " + ratio + '/10' : ''}</p>

                {likes === 0 && dislikes === 0 &&
                    <p>{t("not_rated_1")}</p>
                }

                {likes === 0 && dislikes > 0 &&
                    <>
                        <p className="negative-rate">{t("rating")}: 0/10</p>
                    </>
                }
            </div>
        </>
    );
}
export default BuildRatio;